import { useEffect, useState } from 'react'
import styles from './ProgressDashLineViewPanel.module.less'
import { DASHBOARD_CONTENT_CONTAINER_ID } from '@/router/pageConst'


interface Props {
  detailMetrics: ProjectModels.DetailMetricItem[]
  xAxisDots: Array<{ x: number, dots: Array<{ x: number, y: number }> }>
  activeXAxisIndex: number
  parentRect: DOMRect | null
  orientation?: 'landscape' | 'portrait'
}

const LANDSCAPE_HEAT_MAP_WIDTH = 160
const LANDSCAPE_HEAT_MAP_HEIGHT = 90
const PORTRAIT_HEAT_MAP_WIDTH = 90
const PORTRAIT_HEAT_MAP_HEIGHT = 160
const HEAT_MAP_PADDING = 3

function ProgressDashLineViewPanel(props: Props) {
  const [point, setPoint] = useState<{ x: number, y: number, heatMap: string } | null>(null)
  const isPortrait = props.orientation === 'portrait'
  const heatMapWidth = isPortrait ? PORTRAIT_HEAT_MAP_WIDTH : LANDSCAPE_HEAT_MAP_WIDTH
  const heatMapHeight = isPortrait ? PORTRAIT_HEAT_MAP_HEIGHT : LANDSCAPE_HEAT_MAP_HEIGHT

  useEffect(() => {
    const targetXAxisIndex = props.activeXAxisIndex
    if (targetXAxisIndex < 0) {
      setPoint(null)
      return
    }
    if (!props.parentRect) {
      setPoint(null)
      return
    }
    const dashboardContentContainer = document.getElementById(DASHBOARD_CONTENT_CONTAINER_ID)
    if (!dashboardContentContainer) {
      setPoint(null)
      return
    }
    const metric = props.detailMetrics[targetXAxisIndex]
    const axisDot = props.xAxisDots[targetXAxisIndex]
    if (!metric || !axisDot || axisDot.dots.length === 0) {
      setPoint(null)
      return
    }
    const dashboardContentContainerRect = dashboardContentContainer.getBoundingClientRect()
    const dashboardContentContainerLeft = dashboardContentContainerRect.left
    const containerLeft = props.parentRect.left
    const containerAndDashboardOffset = containerLeft - dashboardContentContainerLeft
    const heatMap = metric.heatMap
    if (!heatMap) {
      setPoint(null)
      return
    }
    const dots = axisDot.dots
    const maxDotY = Math.max(...dots.map(dot => dot.y))
    const minDotY = Math.min(...dots.map(dot => dot.y))
    const averageY = (maxDotY + minDotY) / 2
    const targetY = averageY - (heatMapHeight + HEAT_MAP_PADDING * 2) / 3
    const x = axisDot.x
    /** DELTA 是热力图距离虚线的间距 */
    const DELTA = 20
    let targetX = x - heatMapWidth - HEAT_MAP_PADDING * 2 - DELTA
    /** 如果热力图超出边界，则改为在右边展示 */
    if (targetX < 0 && Math.abs(targetX) > containerAndDashboardOffset) {
      /**
       * DELTA * 2 是大概设置的间距值，实际应该不覆盖到 label 就行了，
       * 但是这里再去传入 label 间距和宽度我嫌太麻烦了，所以就用 DELTA * 2 来设置间距,
       * 懂得都懂
       */
      targetX = x + HEAT_MAP_PADDING * 2 + DELTA * 2
    }
    setPoint({ x: targetX, y: targetY, heatMap })
  }, [props.activeXAxisIndex, props.xAxisDots, props.detailMetrics, props.parentRect])

  return point && <div className={styles.progressDashLineViewPanel} style={{
    position: 'absolute',
    zIndex: 3,
    bottom: point.y,
    left: point.x,
    padding: HEAT_MAP_PADDING
  }}>
    <div className={styles.content}>
      <img className={styles.heatMap} src={point.heatMap} alt="" style={{
        width: heatMapWidth,
        height: heatMapHeight,
      }} />
    </div>
  </div>
}

export default ProgressDashLineViewPanel
